import ChainFusionClient from '../clients/ChainFusionClient'
import { keychainManager } from '../keyring'
import getAgent from './getAgent'

export const getChainFusionClient = async (wallet: string) => {
  const identity = await keychainManager.getIdentity(wallet)
  const signAgent = getAgent({ identity })

  return new ChainFusionClient(signAgent)
}
